import DataFiltering from "./dataFiltering";

const DataHandling = (data, filter, appConfigOptions) => {

    let movingAverageRange = appConfigOptions.movingAverageRange;
    DataFiltering(movingAverageRange, filter, data.data, data.type);

}

export default DataHandling;